Auth = require 'app/scripts/db/auth'
BoardSelectOrganizationView = require 'app/scripts/views/board-menu/board-select-organization-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
popoverBoardHeaderOrgMenu = require 'app/scripts/views/templates/popover_board_header_org_menu'
{ track } = require '@trello/analytics'
{ dontUpsell } = require '@trello/config'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ Analytics } = require '@trello/atlassian-analytics'

module.exports = class BoardHeaderOrgMenuView extends View
  getViewTitle: -> @model.getOrganization().get('displayName')

  events:
    'click .js-change-org': 'openChangeOrg'
    'click .js-view-org': 'viewOrg'
    'click .js-upgrade-to-bc': 'trackBcUpgrade'

  render: ->
    org = @model.getOrganization()

    data = org.toJSON()

    # If you're the org owner, you can change the organization to nothing
    # If you're the board owner, you can change the organization to whatever
    data.canChangeOrg = org?.owned() || @model.owned()
    data.isOrgMember = org.isMember(Auth.me())

    if org?.owned() && !@model.owned()
      data.setOrgNull = true

    data.upsellEnabled = !dontUpsell

    @$el.html(popoverBoardHeaderOrgMenu(data))

    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendScreenEvent
        name: 'boardOrganizationInlineDialog'
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id

    @

  openChangeOrg: (e) ->
    Util.stop(e)
    if @model.owned()
      PopOver.pushView
        view: BoardSelectOrganizationView
        options:
          model: @model
          modelCache: @modelCache

      track("Board Header", "Change Org from Board Header Org Menu")
      if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
        Analytics.sendClickedLinkEvent
          linkName: 'changeBoardOrganizationLink'
          source: 'boardOrganizationInlineDialog'
          containers:
            board:
              id: @model.id
            organization:
              id: @model.getOrganization()?.id

    else
      idOrg = @model.get('idOrganization')
      @modelCache.get('Organization', idOrg)?.boardList.remove(@model)
      @model.update 'idOrganization', ''
      PopOver.hide()

      track("Board Header", "Remove Org from Board Header Org Menu")
      Analytics.sendUpdatedBoardFieldEvent
        field: 'organization'
        source: 'boardOrganizationInlineDialog'
        containers:
          board:
            id: @model.id,
          organization:
            id: @model.getOrganization()?.id # Removed, so should be undefined
        attributes:
          previous: idOrg
    return

  viewOrg: ->
    track("Board Header", "View Org From Board Header Org Menu")
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendClickedLinkEvent
        linkName: 'viewOrganizationLink'
        source: 'boardOrganizationInlineDialog'
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id

  trackBcUpgrade: ->
    track("Board Header", "Org Menu", "Upgrade to Business Class link")
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendClickedLinkEvent
        linkName: 'upgradeToBCLink'
        source: 'boardOrganizationInlineDialog'
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id
